import { render, staticRenderFns } from "./UserLocationForm.vue?vue&type=template&id=125a0e7e&scoped=true&"
import script from "./UserLocationForm.vue?vue&type=script&lang=js&"
export * from "./UserLocationForm.vue?vue&type=script&lang=js&"
import style0 from "./UserLocationForm.vue?vue&type=style&index=0&id=125a0e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a0e7e",
  null
  
)

export default component.exports